import React from "react";

export default function Break() {
  return (
    <div>
      <br />
    </div>
  );
}
